<gtd-action-button [config]="config" [className]="className" [id]="id" [repository]="repository">
  <button p500-ui-button [stroked]="stroked" [size]="size" [classIcon]="classIcon"
    [positionIcon]="positionIcon" [color]="color">
    {{ title }}
  </button>
</gtd-action-button>